(() => {
  const mount = (root = document) => {
    root.querySelectorAll('[data-flavor-card]').forEach(card => {
      if (card.dataset.flavorReady) return;
      const options = [...card.querySelectorAll('[data-flavor-option]')];
      const images = [...card.querySelectorAll('[data-flavor-image]')];
      const details = [...card.querySelectorAll('[data-flavor-details]')];
      const title = card.querySelector('[data-flavor-title]');
      const update = (announce = false) => {
        const selected = options.find(option => option.checked);
        const handle = selected.value;
        const image = images.find(node => node.dataset.flavorImage === handle);
        const detail = details.find(node => node.dataset.flavorDetails === handle);
        if (!image || !detail) return;
        images.forEach(node => { node.hidden = node !== image; });
        details.forEach(node => { node.hidden = node !== detail; });
        title.href = image.href;
        card.dataset.productHandle = handle;
        if (announce) card.querySelector('[data-flavor-status]').textContent = `${selected.nextElementSibling.textContent} selected. ${detail.querySelector('.gp-price').childNodes[0].textContent.trim()}.`;
      };
      options.forEach(option => option.addEventListener('change', () => update(true))); 
      update();
      card.querySelector('[data-flavor-control]').hidden = false;
      card.dataset.flavorReady = 'true';
    });
  };
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
